import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/images/icon_warning_yellow.svg'
import _imports_1 from '@/assets/images/icon_link.svg'


const _hoisted_1 = {
  key: 0,
  class: "c-header__title"
}
const _hoisted_2 = { class: "c-header__default-wrapper" }
const _hoisted_3 = { class: "c-header__project-box" }
const _hoisted_4 = { class: "c-header__project-tit" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "c-header__project-title"
}
const _hoisted_8 = {
  key: 1,
  class: "c-header__project-title"
}
const _hoisted_9 = {
  key: 2,
  class: "c-header__project-title"
}
const _hoisted_10 = {
  key: 3,
  class: "c-header__project-title"
}
const _hoisted_11 = {
  key: 4,
  class: "c-header__project-tab"
}
const _hoisted_12 = {
  key: 5,
  class: "c-header__project-tab"
}
const _hoisted_13 = {
  key: 6,
  class: "c-header__project-tab"
}
const _hoisted_14 = {
  key: 7,
  class: "c-header__project-tab"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 1,
  class: "c-header__project-list"
}
const _hoisted_17 = ["onClick", "disabled"]
const _hoisted_18 = { style: { marginRight: '7px' } }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "c-header__body"
}
const _hoisted_21 = { class: "c-header__drop-area" }
const _hoisted_22 = { class: "c-header__user-name" }
const _hoisted_23 = {
  key: 1,
  class: "c-header__body"
}
const _hoisted_24 = { class: "c-header__desc" }
const _hoisted_25 = {
  key: 1,
  class: "c-header__link-wrapper"
}
const _hoisted_26 = {
  key: 0,
  class: "c-header__project-link"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  src: _imports_1,
  class: "c-metaImage",
  alt: "Icon"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "c-icon c-icon--close" }
const _hoisted_32 = { class: "s-hide" }
const _hoisted_33 = { class: "c-icon c-icon--plus-gray" }
const _hoisted_34 = { class: "s-hide" }
const _hoisted_35 = { class: "link-pop" }
const _hoisted_36 = { class: "link-pop__label" }
const _hoisted_37 = {
  key: 0,
  class: "c-header__menu-wrapper"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { key: 4 }
const _hoisted_43 = { key: 5 }
const _hoisted_44 = { key: 6 }
const _hoisted_45 = { key: 7 }
const _hoisted_46 = { key: 8 }
const _hoisted_47 = { key: 9 }
const _hoisted_48 = {
  key: 10,
  class: "c-header__mo-project"
}
const _hoisted_49 = {
  key: 1,
  class: "c-header__project-list"
}
const _hoisted_50 = ["onClick", "disabled"]
const _hoisted_51 = { style: { marginRight: '7px' } }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 11,
  class: "c-header__mo-project"
}

import { ref, computed, watch, inject, onBeforeUnmount, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import isEmpty from 'lodash/isEmpty';

import { Http } from '@/shared/api/api';

import BasePopup from '@/components/BasePopup.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseButton from '@/components/BaseButton.vue';
import DefaultProfileImage from '@/components/DefaultProfileImage.vue';

import { profileStore } from '@/stores/profile';
import { userStore } from '@/stores/authStore';
import { projectStore } from '@/stores/project';
import { roleStore } from '@/stores/role';
import { projectListStore } from '@/stores/projectList';

import { FormProfile } from '@/shared/types/Profile';
import { Link } from '@/shared/types/Link';
import { Project, ProjectStatus } from '@/shared/types/Project';

import { ensureHttps } from '@/utils';
import { openUrl } from '@/utils/url';

import { getMemberProjectInfo } from '@/api/timeline';

import { useProjectSetting } from '@/stores/settingMenuStoreMo';
import { $t } from '@/plugins/translation';


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  type: {
    type: String,
    default: 'home',
  },
},
  setup(__props) {

const { toggleSetting, handleSettingProject } = useProjectSetting();

const props = __props;

// check device
const isMobile = ref(false);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
}

const route = useRoute();

const authStore = userStore();

const moduleRole = roleStore();
const selectedProject = projectStore();
const projectList = projectListStore();
// const dropboxRef = ref(null);

const $toast = inject('$toast') as Function;
const $ga = inject('$ga') as any;

const dropdownRef = ref<HTMLDivElement | null>(null);
const isDropbox = ref(false);
const projectDropbox = ref(false);

const profileInfo = profileStore();
const profile = computed(() => profileInfo.profile as FormProfile);
// const projectList = ref<ProjectList[]>([]);
const urlList = ref<Link[]>([]);

const selectedProjectName = computed(() => selectedProject.selectedProject?.name);

const onErrorImage = (event: Event): void => {
  const target = event.target as HTMLImageElement;
  target.src = '@/assets/images/icon_link.svg';
};

const handleDropbox = () => {
  !isDropbox.value ? handleOpen() : handleClose();
};
const handleOpen = () => {
  isDropbox.value = true;
  window.addEventListener('mousedown', handleOutside);
};
const handleClose = () => {
  isDropbox.value = false;
  window.removeEventListener('mousedown', handleOutside);
};

const handleOutside = (e: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target as Node)) {
    handleClose();
  }
};

const handleProfile = () => {
  isDropbox.value = !isDropbox.value;
  try {
    $ga?.trackEvent?.('gnb_click', { label: 'profile' });
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[GA] gnb profile error', e);
  }
  router.push('/profile');
};

const isProject = async () => {
  projectDropbox.value = !projectDropbox.value;
  try {
    $ga?.trackEvent?.('gnb_click', { label: 'project_selector', state: projectDropbox.value ? 'open' : 'close' });
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[GA] gnb project_selector error', e);
  }
};

const settingPageMenuTitle = ref('');

const fetchSettingPageMenuTitle = (text: string) => {
  settingPageMenuTitle.value = text;
  handleSettingProject();
};

const handleGetMemberInfo = async () => {
  try {
    const response = await getMemberProjectInfo({ projectIdx: selectedProject.selectedProjectId });
    if (response?.status !== 200) return;
    moduleRole.userRoles = response.data?.roles || [];
    moduleRole.currentRole = moduleRole.userRoles[0]?.role?.name;
    selectedProject.selfProjectIdx = response.data?.memberInProjectIdx;
  } catch (error) {
    console.error(error);
  }
};

const handleSelectProject = async (project: any) => {
  projectDropbox.value = false;
  selectedProject.selectedProject = project;
  try {
    $ga?.trackEvent?.('gnb_click', { label: 'project_switch', project: project?.name, projectIdx: project?.projectIdx });
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[GA] gnb project_switch error', e);
  }

  let newPath = '';

  switch (props.type) {
    case 'calculate':
      newPath = `/calculate/expert/${project.projectIdx}`;
      break;
    case 'dashboard':
      newPath = `/dashboard/${project.projectIdx}`;
      break;
    case 'timeline':
      newPath = `/timeline/${project.projectIdx}`;
      break;
    case 'request':
      newPath = `/request/${project.projectIdx}`;
      break;
    case 'setting':
      newPath = `/setting/${project.projectIdx}`;
      break;
    case 'epic':
      newPath = `/epic/${project.projectIdx}`;
      break;
    case 'doclist':
      newPath = `/doclist/${project.projectIdx}`;
      break;
    case 'pilot':
      newPath = `/pilot/${project.projectIdx}`;
      break;
    default:
      break;
  }

  router.push(newPath);
};

const goToSetting = (idx: number) => {
  router.push(`/setting?idx=${idx}`);
};

const renderLabelRole = computed(() => {
  return moduleRole.isClient ? $t('common', 'client') : $t('common', 'professional');
});

const isLink = ref(false);
const newLink = ref('');
const popupLink = () => {
  isLink.value = !isLink.value;
};
const addLink = async () => {
  if (newLink.value) {
    method.createLinks();
    newLink.value = '';
  }
};

const handleGetProjectList = async (isClient: boolean) => {
  const projectListTmp = isClient ? projectList.client : projectList.professional;
  if (!route.query.selectedStory && !route.query.selectedMilestone)
    selectedProject.isInAProject = !isEmpty(projectListTmp);
  else selectedProject.isInAProject = true;

  if (!selectedProject.isInAProject) return router.push({ name: 'No project' });
  const listCurrentProjectIds = projectListTmp.map((project: Project) => project?.projectIdx);

  if (route.params.id && Number(route.params.id) !== selectedProject.selectedProjectId) {
    const foundProject = projectList.allProjects.find(
      (project: Project) => project.projectIdx === Number(route.params.id),
    );
    if (foundProject) {
      selectedProject.selectedProject = foundProject;
      return;
    } else return router.push({ name: 'Permission denied' });
  }

  if (
    !selectedProject.selectedProjectId ||
    !listCurrentProjectIds.includes(selectedProject.selectedProjectId as number)
  )
    selectedProject.selectedProject = projectListTmp[0];

  router.replace({ params: { id: selectedProject.selectedProjectId }, query: { ...route.query } });

  await handleGetMemberInfo();
};

const handleChangeRole = async () => {
  moduleRole.isClient = !moduleRole.isClient;
  $toast({
    icon: 'green',
    desc: moduleRole.isClient
      ? $t('component.header', 'convertClient')
      : $t('component.header', 'convertProfessional'),
  });
  try {
    $ga?.trackEvent?.('gnb_click', { label: 'role_toggle', role: moduleRole.isClient ? 'client' : 'professional' });
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[GA] gnb role_toggle error', e);
  }
  if (route.name === 'home') return;
  if (!['setting', 'No project', 'Permission denied'].includes(route.name as string))
    handleGetProjectList(moduleRole.isClient);
  router.push('/');
};

const isMenuOpen = ref(false);

const handleOpenMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  const menu = document.querySelector('.c-lnb.mo'); // .c-lnb.mo 요소 찾기
  if (!menu) {
    return;
  }
  menu.style.left = isMenuOpen.value ? '0rem' : '-27.2rem';
  try {
    $ga?.trackEvent?.('gnb_click', { label: 'mobile_menu_toggle', state: isMenuOpen.value ? 'open' : 'close' });
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[GA] gnb mobile_menu_toggle error', e);
  }
}

const handleMenuOutside = (e: MouseEvent) => {
  const menu = document.querySelector('.c-lnb.mo');
    if (menu && !menu.contains(e.target)) {
      menu.style.left = '-100%';
    }
};

const method = {
  handleLogOut: async () => {
    isDropbox.value = !isDropbox.value;
    await Http.api()
      .post('/auth/logout', {})
      .then(() => {
        authStore.reset();
        moduleRole.reset();
        // selectedProject.reset();
        profileInfo.reset();
        projectList.reset();
        try {
          $ga?.trackEvent?.('auth_logout');
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') console.debug('[GA] auth_logout error', e);
        }
        router.push('/');
      })
      .catch((err) => {
        console.log(err);
      });
  },
  getLinks: async () => {
    await Http.api()
      .get(`/link`, { projectIdx: selectedProject.selectedProjectId })
      .then((res) => {
        if (res && res.data) {
          urlList.value = res.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  createLinks: async () => {
    await Http.api()
      .post(`/link`, {
        url: ensureHttps(newLink.value),
        projectIdx: selectedProject.selectedProjectId,
      })
      .then((res) => {
        if (res && res.data) {
          method.getLinks();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  removeLink: async (linkIdx: number) => {
    await Http.api()
      .delete(`/link/${linkIdx}`)
      .then((res) => {
        console.log(res);
        method.getLinks();
      })
      .catch((err) => {
        console.log(err);
      });
  },
  getProjectList: async () => {
    if (!projectList.isFetchProject)
      await Http.api()
        .get('/project/list-of-member')
        .then((res) => {
          if (!res || !res.data) return;
          else projectList.allProjects = res.data;
          projectList.isFetchProject = true;
        })
        .catch((err) => {
          console.log(err);
        });
  },
};

watch(
  () => route.path,
  async () => {
    projectDropbox.value = false;
    if (selectedProject.selectedProjectId && route.name === 'Timeline') await method.getLinks();
    if (
      !['setting', 'No project', 'Permission denied', 'home', 'Profile'].includes(
        route.name as string,
      ) &&
      authStore.login
    ) {
      method.getProjectList().then(() => {
        handleGetProjectList(moduleRole.isClient);
      });
    }
  },
  { immediate: true },
);

onMounted(() => {
  checkIsMobile();
  fetchSettingPageMenuTitle('');
  window.addEventListener('mousedown', handleMenuOutside); // 클릭 이벤트 추가
});

onBeforeUnmount(() => {
  window.removeEventListener('mousedown', handleOutside);
  window.removeEventListener('mousedown', handleMenuOutside);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({
      'c-header': true,
      'c-header__timeline': __props.type === 'timeline' || __props.type === 'request',
      'mo': isMobile.value,
      'pc': !isMobile.value,
    })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-header__wrap", {'!flex-col' : isMobile.value && __props.type==='timeline',
      }
    ])
    }, [
      (['home', 'recruitment'].includes(__props.type) && !isMobile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: '/',
              class: "c-header__logo"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "c-icon c-icon--logo" }, [
                  _createElementVNode("span", { class: "s-hide" }, "EPOSO")
                ], -1)
              ])),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: '/',
                    class: "c-header__logo"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "c-icon c-icon--logo" }, [
                        _createElementVNode("span", { class: "s-hide" }, "EPOSO")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (__props.type === 'dashboard')
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_unref($t)('component.header', 'dashboard')), 1))
                    : (__props.type === 'timeline')
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_unref($t)('component.header', 'timeline')), 1))
                      : (__props.type === 'request')
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_unref($t)('common', 'request')), 1))
                        : (__props.type === 'calculate')
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_unref($t)('component.header', 'settlement')), 1))
                          : (__props.type === 'setting')
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_11, [
                                _createElementVNode("div", null, _toDisplayString(_unref($t)('component.header', 'settings')), 1)
                              ]))
                            : (__props.type === 'epic')
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                                  _createElementVNode("div", null, _toDisplayString(_unref($t)('common', 'epic')), 1)
                                ]))
                              : (__props.type === 'doclist')
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_13, [
                                    _createElementVNode("div", null, _toDisplayString(_unref($t)('common', 'doclist')), 1)
                                  ]))
                                : (__props.type === 'pilot')
                                  ? (_openBlock(), _createElementBlock("h3", _hoisted_14, [
                                      _createElementVNode("div", null, _toDisplayString(_unref($t)('component.header', 'pilot')), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (['dashboard', 'timeline', 'calculate', 'epic', 'doclist', 'request'].includes(__props.type))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: isProject,
                        class: "c-header__project"
                      }, _toDisplayString(selectedProjectName.value), 1))
                    : _createCommentVNode("", true),
                  (projectDropbox.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moduleRole).isClient
                  ? _unref(projectList).client
                  : _unref(projectList).professional, (item, idx) => {
                          return (_openBlock(), _createElementBlock("button", {
                            style: { display: 'flex' },
                            type: "button",
                            key: item?.projectIdx,
                            onClick: ($event: any) => (
                  item.status === _unref(ProjectStatus).ACTIVE ? handleSelectProject(item) : goToSetting(idx)
                ),
                            disabled: item.status === _unref(ProjectStatus).INACTIVE
                          }, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.name), 1),
                            (item.status === _unref(ProjectStatus).INACTIVE)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _cache[9] || (_cache[9] = [
                                  _createElementVNode("img", {
                                    class: "size-[16px]",
                                    src: _imports_0
                                  }, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_17))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (profile.value.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "c-header__user-btn",
                  onClick: handleDropbox
                }, [
                  _createVNode(DefaultProfileImage, {
                    profileForm: profile.value,
                    ableShowProfile: false,
                    onClick: handleDropbox
                  }, null, 8, ["profileForm"]),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(profile.value.nickname), 1)
                ]),
                (isDropbox.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "c-header__dropbox",
                      ref_key: "dropdownRef",
                      ref: dropdownRef
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "c-header__drop-btn",
                        onClick: handleProfile
                      }, _toDisplayString(_unref($t)('component.header', 'profile')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "c-header__drop-btn",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (method.handleLogOut && method.handleLogOut(...args)))
                      }, _toDisplayString(_unref($t)('component.header', 'logout')), 1)
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["c-header__user-tag", _unref(moduleRole).isClient ? 'customer' : 'expert']),
                onClick: handleChangeRole
              }, [
                _createTextVNode(_toDisplayString(renderLabelRole.value) + " ", 1),
                _createElementVNode("i", {
                  class: _normalizeClass(['c-icon', _unref(moduleRole).isClient ? 'c-icon--change__green' : 'c-icon--change'])
                }, null, 2)
              ], 2)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref($t)('component.header', 'noLoggedIn')), 1),
              _createVNode(BaseButton, {
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)('component.header', 'loginJoin')), 1)
                ]),
                _: 1
              })
            ]))
      ]),
      (__props.type === 'timeline')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (__props.type === 'timeline')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urlList.value, (url) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "c-header__project-fixed cursor-pointer",
                      key: url.linkIdx,
                      onClick: ($event: any) => (_unref(openUrl)(url.url))
                    }, [
                      (url.metaImage)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: url.metaImage,
                            class: "c-metaImage",
                            alt: "Icon",
                            onError: onErrorImage
                          }, null, 40, _hoisted_28))
                        : (_openBlock(), _createElementBlock("img", _hoisted_29)),
                      _createElementVNode("p", null, _toDisplayString(url.metaTitle), 1),
                      (!_unref(moduleRole).isClient)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "c-header__delete",
                            onClick: _withModifiers(($event: any) => (method.removeLink(url.linkIdx)), ["stop","prevent"])
                          }, [
                            _createElementVNode("i", _hoisted_31, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref($t)('common', 'delete')), 1)
                            ])
                          ], 8, _hoisted_30))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_27))
                  }), 128)),
                  (!_unref(moduleRole).isClient)
                    ? (_openBlock(), _createBlock(BaseButton, {
                        key: 0,
                        icon: true,
                        size: "xxsmall",
                        color: "outline",
                        onClick: popupLink
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_unref($t)('common', 'delete')), 1)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref($t)('common', 'link')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(BasePopup, {
                    title: _unref($t)('component.header', 'addLink'),
                    modelValue: isLink.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isLink).value = $event)),
                    confirmText: _unref($t)('common', 'save'),
                    onConfirm: addLink
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_unref($t)('common', 'link')), 1),
                        _createVNode(BaseInput, {
                          modelValue: newLink.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newLink).value = $event)),
                          placeholder: "www.eposo.ai",
                          onKeyup: _cache[3] || (_cache[3] = _withKeys(
                () => {
                  isLink.value = false;
                  addLink();
                }
              , ["enter"]))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title", "modelValue", "confirmText"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (isMobile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("i", {
            class: "c-icon--menu-mo",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (handleOpenMenu()))
          }),
          (__props.type === 'home')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_38, _toDisplayString(_unref($t)('common', 'home')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'calculate')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_39, _toDisplayString(_unref($t)('component.header', 'settlement')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'dashboard')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_40, _toDisplayString(_unref($t)('component.header', 'dashboard')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'epic')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_41, _toDisplayString(_unref($t)('common', 'epic')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'timeline')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_42, _toDisplayString(_unref($t)('component.header', 'timeline')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'request')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_43, "Request"))
            : _createCommentVNode("", true),
          (__props.type === 'request')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_44, _toDisplayString(_unref($t)('common', 'request')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'setting')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_45, _toDisplayString(_unref($t)('common', 'setting')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'doclist')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_46, _toDisplayString(_unref($t)('common', 'doclist')), 1))
            : _createCommentVNode("", true),
          (__props.type === 'recruitment')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_47, _toDisplayString("공고")))
            : _createCommentVNode("", true),
          (isMobile.value && (
          ['dashboard', 'timeline', 'calculate', 'epic', 'request'].includes(__props.type)
        ))
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                (['dashboard', 'timeline', 'calculate', 'epic', 'request'].includes(__props.type))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: isProject,
                      class: "c-header__project"
                    }, _toDisplayString(selectedProjectName.value), 1))
                  : _createCommentVNode("", true),
                (projectDropbox.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moduleRole).isClient
              ? _unref(projectList).client
              : _unref(projectList).professional, (item, idx) => {
                        return (_openBlock(), _createElementBlock("button", {
                          style: { display: 'flex' },
                          type: "button",
                          key: item?.projectIdx,
                          onClick: ($event: any) => (
              item.status === _unref(ProjectStatus).ACTIVE ? handleSelectProject(item) : goToSetting(idx)
            ),
                          disabled: item.status === _unref(ProjectStatus).INACTIVE
                        }, [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(item.name), 1),
                          (item.status === _unref(ProjectStatus).INACTIVE)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, _cache[10] || (_cache[10] = [
                                _createElementVNode("img", {
                                  class: "size-[16px]",
                                  src: _imports_0
                                }, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_50))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isMobile.value && (
            ['setting'].includes(__props.type)
          ))
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(toggleSetting) && _unref(toggleSetting)(...args))),
                  class: "c-header__project c-header__setting-project",
                  id: "moSettingProjectTitle"
                }, _toDisplayString(selectedProjectName.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})